import React from 'react'
import ErrorBoundaryCore from './ErrorBoundaryCore'

export const AppErrorBoundary: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <ErrorBoundaryCore fallbackVariant="app">
    {children}
  </ErrorBoundaryCore>
)

export const RouteErrorBoundary: React.FC<{ children: React.ReactNode; pathname?: string }> = ({
  children,
  pathname,
}) => (
  <ErrorBoundaryCore fallbackVariant="route" pathname={pathname}>
    {children}
  </ErrorBoundaryCore>
)

export { default as ErrorBoundaryCore } from './ErrorBoundaryCore'
export { default as errorReporter } from './errorReporter'
